/* Connect Bloom purchase forms to this theme's existing cart drawer. */
(() => {
  if (window.bloomThemeCartInstalled) return;
  window.bloomThemeCartInstalled = true;
  let pending = false;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-bl-product-form]')) return;
    const root = form.closest('bloom-editable');
    const drawer = document.querySelector('cart-drawer');
    if (!root || !drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') return;

    event.preventDefault();
    if (pending) return;
    pending = true;
    const trigger = event.submitter || form.querySelector('[type="submit"]');
    const controls = [...document.querySelectorAll('bloom-editable [data-bl-product-form] [type="submit"], bloom-editable [data-bl-variant-picker]')];
    const states = controls.map(control => [control, control.disabled]);
    const cartUrl = window.routes?.cart_url || form.querySelector('[name="return_to"]')?.value || '/cart';
    let status = form.querySelector('[data-bl-cart-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.blCartStatus = '';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.append(status);
    }
    document.querySelectorAll('bloom-editable [data-bl-cart-status]').forEach(node => { node.hidden = true; });
    status.textContent = 'Adding to your cart…';
    status.hidden = false;
    form.setAttribute('aria-busy', 'true');
    controls.forEach(control => { control.disabled = true; });
    let added = false;
    try {
      const sections = drawer.getSectionsToRender();
      const body = new FormData(form);
      body.delete('return_to');
      body.set('sections', sections.map(section => section.id).join(','));
      body.set('sections_url', window.location.pathname);
      const endpoint = new URL(form.action, window.location.origin);
      endpoint.pathname = endpoint.pathname.replace(/\/add(?:\.js)?\/?$/, '/add.js');
      const response = await fetch(endpoint.href, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        if (response.status >= 500) throw new Error('Unconfirmed cart response');
        status.textContent = typeof result.description === 'string' ? result.description : 'This item could not be added. Please check its availability.';
        return;
      }
      added = true;
      // Adding succeeded even when Shopify cannot render a requested section.
      // Visit the cart in that case; never repeat the add request.
      if (!sections.every(section => typeof result.sections?.[section.id] === 'string' && result.sections[section.id].trim())) {
        window.location.assign(cartUrl);
        return;
      }
      drawer.setActiveElement?.(trigger);
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      status.hidden = true;
    } catch (error) {
      if (added) {
        window.location.assign(cartUrl);
        return;
      }
      status.textContent = 'We could not confirm the cart update. Check your cart before trying again. ';
      const link = document.createElement('a');
      link.href = cartUrl;
      link.textContent = 'View cart';
      status.append(link);
    } finally {
      states.forEach(([control, disabled]) => { control.disabled = disabled; });
      form.removeAttribute('aria-busy');
      pending = false;
    }
  });
})();
